/**
 * The arrow and color for a hero change line, "▲ +1.7%" in green or
 * "▼ −1.2%" in red. Used by the dashboard and account page hero numbers.
 */

/** A change smaller than this either way (0.005 = 0.5%) gets no arrow or color. */
export const CHANGE_FLAT_BAND = 0.005;

/** Arrow and color for a change: up, down, or flat. */
export function changeTone(change: number | null): "up" | "down" | "flat" {
  // Nothing to compare against
  if (change === null || !Number.isFinite(change)) return "flat";
  // Up by at least half a percent
  if (change >= CHANGE_FLAT_BAND) return "up";
  // Down by at least half a percent
  if (change <= -CHANGE_FLAT_BAND) return "down";
  // Too small to call either way
  return "flat";
}

/** Arrow and text color for each tone. */
export const CHANGE_TONE = {
  up: { glyph: "▲ ", className: "text-si-up" }, // good news
  down: { glyph: "▼ ", className: "text-si-down" }, // bad news
  flat: { glyph: "", className: "text-si-ink-3" }, // neither
};
